import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { MsalService } from '@azure/msal-angular';
// import { MsAdalAngular6Service } from 'microsoft-adal-angular6';
import moment from 'moment';
import { Subject, Subscription } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { AuthService } from 'src/app/core/services/auth.service.service';
import { DataService } from 'src/app/shared/service/data.service';
import { DataAnalyticsService } from '../../services/data-analytics.service';

@Component({
  selector: 'app-save-tag-popup',
  templateUrl: './save-tag-popup.component.html',
  styleUrls: ['./save-tag-popup.component.scss']
})
export class SaveTagPopupComponent implements OnInit, OnDestroy {

  public selectType = 'new'; // exist, done
  public noteText = '';
  private userDtls: any;

  insertBookmarkSubscription: Subscription;
  removeBookmarkSubscription: Subscription;

  constructor(
    public dialogRef: MatDialogRef<SaveTagPopupComponent>,
    @Inject(MAT_DIALOG_DATA) public data,
    private dataService: DataService,
    private dataAnalyticService: DataAnalyticsService,
    private router: Router,
    public auth: AuthService,
    public authService: MsalService

  ) { }

  ngOnInit() {
    try {
      if (!this.data.isSaved) {
        this.selectType = 'exist';
      }
      if (this.auth.checkIsAuthticated) {
        this.userDtls = this.authService.getAccount();
      }

    } catch (error) {

    }
  }

  savePage() {
    try {
      let currDate = '';

      if (this.data.filterType === 'quarter') {
        currDate = moment(this.data.currDate.split('|')[0]).format('MMM') + '-' +
          moment(this.data.currDate.split('|')[1]).format('MMM') + ' ' +
          moment(this.data.currDate.split('|')[0]).format('YYYY');

      } else if (this.data.filterType === 'year') {
        currDate = moment(this.data.currDate).format('YYYY');

      } else if (this.data.filterType === 'month') {
        currDate = moment(this.data.currDate).format('MMMM') + ' ' +
          moment(this.data.currDate).format('YYYY');

      }

      const request = {
        ScreenName: this.data.name + ' Insights - ' + currDate,
        URL: window.location.href,
        Notes: this.noteText,
        CreatedBy: this.userDtls.userName
      };

      this.insertBookmarkSubscription = this.dataAnalyticService.insertBookmark(request)
        .subscribe((data) => {
          if (data && data.message && data.message === 'Ok') {
            this.selectType = 'done';
          }
        }, err => {

        });

    } catch (error) {

    }
  }

  deletePage() {
    try {
      this.removeBookmarkSubscription = this.dataAnalyticService.deleteBookmark({ Id: this.data.id })
        .subscribe((data) => {
          if (data && data.result === 'Success') {
            this.dialogRef.close('delete');
          }
        }, err => {

        });
    } catch (error) {

    }
  }

  dialogClose() {
    try {
      this.dialogRef.close('save');
    } catch (error) {

    }
  }

  ngOnDestroy(): void {
    if (this.insertBookmarkSubscription) {
      this.insertBookmarkSubscription.unsubscribe();
    }
    if (this.removeBookmarkSubscription) {
      this.removeBookmarkSubscription.unsubscribe();
    }
  }

}
